import React from 'react';
import { Box, Slider, FormControlLabel, Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SONOS_BLUE, sonosSwitchSx } from './sonosUiStyles';

export const formatEqValue = (value: number) => (value > 0 ? `+${value}` : `${value}`);

export const EqSliderRow: React.FC<{
  label: string;
  value: number;
  onChange: (value: number) => void;
  onChangeCommitted?: (value: number) => void;
  disabled?: boolean;
}> = ({ label, value, onChange, onChangeCommitted, disabled }) => (
  <Box sx={{ mb: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 0.75 }}>
      <Typography sx={{ color: '#999', fontSize: 12, fontWeight: 600 }}>{label}</Typography>
      <Typography sx={{ color: SONOS_BLUE, fontSize: 14, fontWeight: 800, fontFamily: 'monospace', minWidth: 28, textAlign: 'right' }}>
        {formatEqValue(value)}
      </Typography>
    </Box>
    <Slider
      value={value}
      min={-10}
      max={10}
      disabled={disabled}
      onChange={(_, v) => onChange(v as number)}
      onChangeCommitted={onChangeCommitted ? (_, v) => onChangeCommitted(v as number) : undefined}
      sx={{ color: SONOS_BLUE }}
    />
  </Box>
);

type SonosEqFieldsProps = {
  bass: number;
  treble: number;
  loudness: boolean;
  onBassChange: (value: number) => void;
  onTrebleChange: (value: number) => void;
  onLoudnessChange: (value: boolean) => void;
  onBassCommit?: (value: number) => void;
  onTrebleCommit?: (value: number) => void;
  disabled?: boolean;
};

export const SonosEqFields: React.FC<SonosEqFieldsProps> = ({
  bass, treble, loudness, onBassChange, onTrebleChange, onLoudnessChange,
  onBassCommit, onTrebleCommit, disabled,
}) => {
  const { t } = useTranslation();
  return (
    <>
      <EqSliderRow label={t('musicSystem.eq.bass')} value={bass} onChange={onBassChange} onChangeCommitted={onBassCommit} disabled={disabled} />
      <EqSliderRow label={t('musicSystem.eq.treble')} value={treble} onChange={onTrebleChange} onChangeCommitted={onTrebleCommit} disabled={disabled} />
      <FormControlLabel
        control={(
          <Switch
            checked={loudness}
            disabled={disabled}
            onChange={(e) => onLoudnessChange(e.target.checked)}
            sx={sonosSwitchSx}
          />
        )}
        label={<Typography sx={{ color: '#fff', fontSize: 13, fontWeight: 600 }}>{t('musicSystem.eq.loudness')}</Typography>}
      />
    </>
  );
};
